"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f243 = void 0;
exports.f243 = {
    "ólusaamya": [
        4497
    ],
    "ọ́lụ́ꞌbọ́ tị": [
        4526
    ],
    "ọ́lụ́ꞌbọ́": [
        4526
    ],
    "ó": [
        9110
    ]
};
